import styled from "styled-components";

export const Flex1 = styled.div`
    flex: 1;
`;
